export default "__VITE_ASSET__Bk_HS50i__"